/**
 * Shared navigation helpers for cross-app drill-downs.
 * Anchor scrolling, filter passing via URL params.
 */

/** Scroll to a section by its HTML id, expanding CollapsibleSection if needed. */
export function scrollToSection(sectionId: string) {
  const element = document.getElementById(sectionId);
  if (!element) return;

  // If the section is a CollapsibleSection and collapsed, click its header button to expand
  const header = element.querySelector('button[type="button"]');
  const contentGrid = element.querySelector('.grid[style]');
  if (contentGrid) {
    const style = (contentGrid as HTMLElement).style.gridTemplateRows;
    if (style === '0fr' && header) {
      (header as HTMLElement).click();
      // Wait for expansion animation before scrolling
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 250);
      return;
    }
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/** Handle anchor scrolling on page mount. Call from useEffect with hash from location. */
export function handleAnchorScroll(hash: string, delay = 500) {
  if (!hash || !hash.startsWith('#')) return;
  const sectionId = hash.slice(1);
  setTimeout(() => scrollToSection(sectionId), delay);
}
